import type { Supplier } from '../types';

export const initialSuppliers: Supplier[] = [
    { id: 1, name: 'Quality Meats NZ', contactPerson: 'John Butcher', phone: '09 123 4567', email: 'sales@qualitymeats.co.nz' },
    { id: 2, name: 'Fresh Veggie Co-op', contactPerson: 'Sarah Farmer', phone: '03 987 6543', email: 'orders@freshveggie.co.nz' },
    { id: 3, name: 'Global Beverage Imports', contactPerson: 'David Importer', phone: '04 555 1234', email: 'david@globalbev.com' },
    { id: 4, name: 'Bakery Essentials Ltd', contactPerson: 'Linda Baker', phone: '07 888 9999', email: 'linda.b@bakeryessentials.co.nz' },
];
